import * as groupsActions from '../actions/groups';
import { objectFromArray } from '../helpers';

const initialState = {
  inflight: false,
  byId: {},
  allIds: [],
  bySiteId: {},
  lastUpdated: null,
};

const groupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case groupsActions.REQUEST_GROUPS:
      return { ...state, inflight: true };

    case groupsActions.RECEIVE_GROUPS:
      return {
        ...state,
        inflight: false,
        allIds: action.groups.map(g => g.id),
        byId: objectFromArray(action.groups, g => g.id),
        bySiteId: {
          ...state.bySiteId,
          [action.siteId]: action.groups.map(g => g.id),
        },
        lastUpdated: action.receivedAt,
      };

    case groupsActions.RECEIVE_GROUP:
    case groupsActions.RECEIVE_GROUP_CREATE:
    case groupsActions.RECEIVE_GROUP_UPDATE: {
      const group = action.group;
      const alreadyExists = state.allIds.includes(group.id);

      return {
        ...state,
        byId: { ...state.byId, [group.id]: group },
        allIds: alreadyExists ? state.allIds : [...state.allIds, group.id],
        bySiteId: {
          ...state.bySiteId,
          [group.site_id]: alreadyExists
            ? (state.bySiteId[group.site_id] || [])
            : [...(state.bySiteId[group.site_id] || []), group.id],
        },
      };
    }

    case groupsActions.RECEIVE_GROUP_DELETE: {
      const { [action.groupId]: removed, ...remainingById } = state.byId;
      const siteId = removed?.site_id;

      return {
        ...state,
        byId: remainingById,
        allIds: state.allIds.filter(id => id !== action.groupId),
        bySiteId: siteId
          ? {
              ...state.bySiteId,
              [siteId]: (state.bySiteId[siteId] || []).filter(id => id !== action.groupId),
            }
          : state.bySiteId,
      };
    }

    default:
      return state;
  }
};

export default groupsReducer;
